module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-1400.9765c1f9.svg";